function a(i, r) {
  const n = {
    ...i
  };
  return new Promise((t, s) => {
    let e;
    r && (e = setTimeout(() => {
      s(new Error(`sendMessage timed out after ${r} ms`));
    }, r)), globalThis?.chrome?.runtime ? chrome.runtime.sendMessage(
      i.extensionId,
      n,
      {},
      (m) => {
        const o = chrome.runtime.lastError;
        o && (e && clearTimeout(e), s(o)), e && clearTimeout(e), t(m);
      }
    ) : (e && clearTimeout(e), s());
  });
}
export {
  a as sendMessage
};
